import { ca } from '@cian/analytics';

export function trackInfrastructureItemClick(blockType: string, objectType?: string) {
  ca('eventSite', {
    action: 'click_object_type',
    category: 'Infrastructure',
    label: objectType,
    name: 'oldevent',
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        block_type: blockType,
      },
    },
  });
}
